import { Component, Input, OnInit } from '@angular/core';

import { DatePipe } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from '@app/shared/services/modal.service';
import { CertificationDetails } from '@app/profile/components/certification-details/certification-details.component';
import { UserOutcomeDetail } from '@app/outcomes/outcomes-api.model';
import { ProfileCollectionItem } from '@app/profile/profile-api.model';

@Component({
  selector: 'dgx-achievement-modal',
  templateUrl: './achievements-modal.component.html',
  styleUrls: ['./achievements-modal.component.scss'],
})
export class AchievementModalComponent implements OnInit {
  // bindings
  @Input() public achievement: UserOutcomeDetail;
  @Input() public isOwner: boolean;
  @Input() public hasImageUrl: boolean;

  public achievementItem: ProfileCollectionItem<UserOutcomeDetail>;

  // local
  public i18n = this.translate.instant([
    'dgUserOutcomeEditForm_StartDate',
    'dgUserOutcomeEditForm_EndDate',
    'dgUserOutcomeEditForm_IssuedBy',
    'dgUserOutcomeEditForm_IssuerUrl',
    'dgUserOutcomeEditForm_GPA',
    'dgUserOutcomeEditForm_Country',
    'dgUserOutcomeEditForm_CollegeUniversity',
    'dgUserOutcomeEditForm_DegreeLevel',
    'dgUserOutcomeEditForm_DateCompleted',
    'dgUserOutcomeEditForm_AwardedDate',
    'dgUserOutcomeEditForm_AchievedDate',
    'dgProfileCollectionItem_CertImage',
    'dgProfileOverview_AwardReceivedDate',
    'dgProfileOverview_CertificateNumber',
    'dgProfileOverview_OverviewNotProvidedTitle',
    'Cred_Certificate_DateIssued',
    'dgUserOutcomeEditForm_Expiration',
    'dgProfileOverview_ViewBadge',
    'dgProfileOverview_ViewDegree',
    'dgProfileOverview_ViewCertificate',
    'dgProfileOverview_ViewAward',
    'Core_Accomplishment',
    'Core_Award',
    'Core_Badge',
    'Core_Certificate',
    'Core_Degree',
    'Core_Image',
  ]);

  public titleTranslationMap = {
    Accomplishment: this.i18n.Core_Accomplishment,
    Award: this.i18n.Core_Award,
    Certificate: this.i18n.Core_Certificate,
    Degree: this.i18n.Core_Degree,
    Badge: this.i18n.Core_Badge,
  };

  public displayedSkillNames: string[] = [];
  public extraSkillCount: number = 0;

  public titleLimit = 50;

  private showSkillsCount: number = 4;

  constructor(
    private activeModal: NgbActiveModal,
    private translate: TranslateService,
    private datePipe: DatePipe,
    private modalService: ModalService
  ) {}

  public ngOnInit(): void {
    const { tags, contentType, userOutcomeId } = this.achievement;
    this.displayedSkillNames = tags
      .slice(0, this.showSkillsCount)
      .map((s) => s.title);
    this.extraSkillCount = tags.length - this.showSkillsCount;

    this.achievementItem = {
      contentType,
      itemId: userOutcomeId,
      userItemId: userOutcomeId,
      content: this.achievement,
    };
  }

  public onCancel(): void {
    this.activeModal.close();
  }

  public onModalMenu(): void {
    this.activeModal.close();
  }

  public viewAttachment = (): void => {
    this.activeModal.close();
    const formattedAchievement = { ...this.achievement };
    formattedAchievement.endDate = this.datePipe.transform(
      formattedAchievement.endDate,
      'MMMM yyyy'
    );
    formattedAchievement.startDate = this.datePipe.transform(
      formattedAchievement.startDate,
      'MMMM yyyy'
    );
    this.modalService
      .show(CertificationDetails, { inputs: { item: formattedAchievement } })
      .subscribe();
  };
}
